import { Button, Card, Space, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

const { Title, Paragraph, Text } = Typography;

const ComingSoon = ({ title = "Coming soon", message }) => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 24 }}>
      <Card
        style={{
          borderRadius: 24,
          boxShadow: "0 18px 50px rgba(15, 23, 42, 0.06)",
          border: "1px solid #e5e7eb",
          maxWidth: 760,
          margin: "0 auto",
        }}
      >
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 18,
              display: "grid",
              placeItems: "center",
              background: "linear-gradient(135deg, #0f172a, #334155)",
              color: "#fff",
            }}
          >
            <LockOutlined />
          </div>
          <div>
            <Text
              style={{
                textTransform: "uppercase",
                letterSpacing: "0.14em",
                color: "#64748b",
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              Not available yet
            </Text>
            <Title level={2} style={{ marginTop: 8 }}>
              {title}
            </Title>
            <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 15 }}>
              {message ||
                "This section is not implemented yet and has been hidden from active navigation where possible."}
            </Paragraph>
          </div>
          <Button type="primary" onClick={() => navigate(paths.pmDashboard)}>
            Go to dashboard
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default ComingSoon;
